import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/icons/CheckIcon.tsx
var r = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M19.293 5.29295C19.6835 4.90243 20.3165 4.90243 20.707 5.29295C21.0975 5.68348 21.0975 6.31649 20.707 6.70702L9.70702 17.707C9.31649 18.0975 8.68348 18.0975 8.29295 17.707L3.29295 12.707C2.90243 12.3165 2.90243 11.6835 3.29295 11.293C3.68348 10.9024 4.31649 10.9024 4.70702 11.293L8.99999 15.5859L19.293 5.29295Z",
		fill: "currentColor"
	})
}), i = {
	12: {
		Artwork: r,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				d: "M12.8033 3.46989C13.0962 3.17716 13.571 3.17705 13.8638 3.46989C14.1564 3.76275 14.1565 4.23762 13.8638 4.53044L6.52983 11.8634C6.23697 12.1563 5.76217 12.1562 5.46928 11.8634L2.13628 8.53044C1.8434 8.23756 1.84342 7.76279 2.13628 7.46989C2.42917 7.177 2.90393 7.177 3.19682 7.46989L5.99956 10.2726L12.8033 3.46989Z",
				fill: "currentColor"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: r,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, tone: r = "default", className: a, ...o }) => /* @__PURE__ */ n(e, {
	source: i[t],
	monochrome: !0,
	className: ["pf-icon-" + r, a].filter(Boolean).join(" "),
	...o
});
//#endregion
export { a as CheckIcon };
